'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RestrictedDomainId$() {
  this.c8g = null;
  this.c8h = false;
  this.c8e = null;
  this.c8f = false;
}
export { $c_Lpresto_types$RestrictedDomainId$ as $c_Lpresto_types$RestrictedDomainId$ };
$p = $c_Lpresto_types$RestrictedDomainId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RestrictedDomainId$;
/** @constructor */
function $h_Lpresto_types$RestrictedDomainId$() {
}
export { $h_Lpresto_types$RestrictedDomainId$ as $h_Lpresto_types$RestrictedDomainId$ };
$h_Lpresto_types$RestrictedDomainId$.prototype = $p;
$p.Gu = (function() {
  if ((!this.c8h)) {
    this.c8g = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.c8h = true;
  }
  return this.c8g;
});
$p.lf = (function() {
  if ((!this.c8f)) {
    this.c8e = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.c8f = true;
  }
  return this.c8e;
});
var $d_Lpresto_types$RestrictedDomainId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RestrictedDomainId$, "presto.types$RestrictedDomainId$", ({
  a1k: 1,
  D: 1
}));
export { $d_Lpresto_types$RestrictedDomainId$ as $d_Lpresto_types$RestrictedDomainId$ };
var $n_Lpresto_types$RestrictedDomainId$;
function $m_Lpresto_types$RestrictedDomainId$() {
  if ((!$n_Lpresto_types$RestrictedDomainId$)) {
    $n_Lpresto_types$RestrictedDomainId$ = new $c_Lpresto_types$RestrictedDomainId$();
  }
  return $n_Lpresto_types$RestrictedDomainId$;
}
export { $m_Lpresto_types$RestrictedDomainId$ as $m_Lpresto_types$RestrictedDomainId$ };
//# sourceMappingURL=presto.types$-Restricted-Domain-Id$.js.map
